import { createFileRoute } from '@tanstack/react-router';
import EmployeesTable from '@/modules/employees/EmployeesTable';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/employee/')({
  component: EmployeesTable,
});
